import { useState } from 'react';

import { ModalBase } from './ModalBase';

import type { FilterOption } from '../../telas/inbox-time/FilterChip';
import type React from 'react';

export function BulkReassignModal({
  open,
  count,
  targets,
  submitting,
  onClose,
  onConfirm,
}: {
  open: boolean;
  count: number;
  targets: FilterOption[];
  submitting: boolean;
  onClose: () => void;
  onConfirm: (p: {
    targetUserId: string;
    reason: string;
    notifyOperators: boolean;
    notifyManager: boolean;
    notifyConversation: boolean;
  }) => void;
}): React.JSX.Element | null {
  const [target, setTarget] = useState(targets[0]?.value ?? '');
  const [reason, setReason] = useState('');
  const [notifyOperators, setNotifyOperators] = useState(true);
  const [notifyConversation, setNotifyConversation] = useState(true);
  const [notifyManager, setNotifyManager] = useState(false);
  if (!open) return null;
  const disabled = submitting || reason.trim().length < 20 || target.length === 0;
  return (
    <ModalBase
      open={open}
      onClose={onClose}
      title={`Reatribuir ${count.toString()} pendência${count === 1 ? '' : 's'} em massa`}
      width={580}
      footer={
        <div style={{ display: 'flex', gap: 8, marginLeft: 'auto' }}>
          <button type="button" className="btn-ghost-mini" onClick={onClose}>
            Cancelar
          </button>
          <button
            type="button"
            className="btn-ghost-mini btn-ghost-mini--primary"
            disabled={disabled}
            onClick={() => {
              onConfirm({
                targetUserId: target,
                reason,
                notifyOperators,
                notifyManager,
                notifyConversation,
              });
            }}
          >
            {submitting ? 'Reatribuindo…' : 'Confirmar reatribuição'}
          </button>
        </div>
      }
    >
      <div className="modal-form">
        <div className="modal-form__callout">
          <b>{count}</b> pendências selecionadas. Configurar reatribuição em massa.
        </div>
        <label className="modal-form__field">
          <span className="modal-form__label">Novo responsável</span>
          <select
            className="modal-form__select"
            value={target}
            onChange={(e) => {
              setTarget(e.target.value);
            }}
          >
            {targets.map((t) => (
              <option key={t.value} value={t.value}>
                {t.label}
              </option>
            ))}
          </select>
        </label>
        <label className="modal-form__field">
          <span className="modal-form__label">Motivo (obrigatório · mínimo 20 caracteres)</span>
          <textarea
            className="modal-form__textarea"
            value={reason}
            onChange={(e) => {
              setReason(e.target.value);
            }}
            rows={3}
            placeholder="Carolina sobrecarregada com 8 pendências hoje. Redistribuindo 3 para João que tem capacidade."
          />
        </label>
        <fieldset className="modal-form__fieldset">
          <legend>Notificações</legend>
          <label className="modal-form__check">
            <input
              type="checkbox"
              checked={notifyOperators}
              onChange={(e) => {
                setNotifyOperators(e.target.checked);
              }}
            />{' '}
            <span>Notificar operadores envolvidos</span>
          </label>
          <label className="modal-form__check">
            <input
              type="checkbox"
              checked={notifyConversation}
              onChange={(e) => {
                setNotifyConversation(e.target.checked);
              }}
            />{' '}
            <span>Adicionar evento nas conversas relacionadas</span>
          </label>
          <label className="modal-form__check">
            <input
              type="checkbox"
              checked={notifyManager}
              onChange={(e) => {
                setNotifyManager(e.target.checked);
              }}
            />{' '}
            <span>Notificar gestor</span>
          </label>
        </fieldset>
        <div className="tweaks-hint">
          Audit log registra cada reatribuição com motivo + operador original + novo.
        </div>
      </div>
    </ModalBase>
  );
}
